import React from "react";
import { Box, MenuItem, TextField, Typography } from "@mui/material";
import { COLORS, CONTENT_MAX_WIDTH, FONT } from "../../shared/styles";
import { formatGroupLabel } from "./constants";
import { ReactComponent as DropdownIcon } from "../../../../../assets/images/dropdown-arrow.svg";
import {
  peopleScrollSelectMenuProps,
  peopleSelectControlSx,
  peopleSelectSx,
} from "../../../People/peopleSelectStyles";

const sectionTitleSx = {
  color: COLORS.textPrimary,
  fontFamily: FONT.family,
  fontSize: "20px",
  fontWeight: 500,
  lineHeight: "34px",
  m: 0,
};

const menuItemSx = {
  fontFamily: "Inter",
  fontSize: 14,
};

function BusinessEmailGroupSelect({ groups, value, onChange, loading }) {
  const selectMenuProps = peopleScrollSelectMenuProps();

  return (
    <Box sx={{ mt: "32px", width: "100%", maxWidth: CONTENT_MAX_WIDTH, mx: "auto" }}>
      <Typography component="h3" sx={sectionTitleSx}>
        Select Group
      </Typography>
      <TextField
        select
        fullWidth
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        disabled={loading || !groups.length}
        sx={{
          ...peopleSelectControlSx({ maxWidth: CONTENT_MAX_WIDTH }),
          mt: "16px",
          width: "100%",
          maxWidth: CONTENT_MAX_WIDTH,
          "& .MuiOutlinedInput-root": {
            height: "40px",
          },
        }}
        SelectProps={{
          displayEmpty: true,
          IconComponent: DropdownIcon,
          MenuProps: selectMenuProps,
          sx: peopleSelectSx,
        }}
      >
        {!groups.length ? (
          <MenuItem value="" disabled sx={menuItemSx}>
            {loading ? "Loading groups..." : "No groups available"}
          </MenuItem>
        ) : (
          groups.map((group) => (
            <MenuItem key={group.id} value={group.id} sx={menuItemSx}>
              {formatGroupLabel(group)}
            </MenuItem>
          ))
        )}
      </TextField>
    </Box>
  );
}

export default BusinessEmailGroupSelect;
